import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { useStormModeIntercept } from './useStormModeIntercept';

export function StormModeInterceptModal() {
  const { t } = useTranslation();
  const { handleSelection, localStorageValue } = useStormModeIntercept();

  if (localStorageValue) {
    handleSelection(localStorageValue);
  }

  return (
    <Dialog
      open={true}
      onClose={() => handleSelection('no')}
      fullWidth
      maxWidth="xs"
      disableScrollLock
    >
      <DialogTitle disableTypography>
        <Typography variant="h2">{t('STORM_MODE_INTERCEPT_TITLE')}</Typography>
      </DialogTitle>
      <DialogContent>{t('STORM_MODE_INTERCEPT_MESSAGE')}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSelection('yes')}
          fullWidth
        >
          {t('VIEW_OUTAGE_INFO')}
        </Button>
        <Button
          variant="outlined"
          onClick={() => handleSelection('no')}
          fullWidth
        >
          {t('GO_TO_DASHBOARD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
